export default "__VITE_ASSET__DTuxLtFG__"